import { MainAccordion } from 'modules/components/common/accordion/main-accordion';
import styled from 'styled-components';
import { Dropdown } from '../dropdown/dropdown';
import { SmbgRows } from './smbg-rows';

export const PatientSmbgData = ({ selectedRangeData }) => {
  const chart = (
    <SmbgRows
      daysWithTest={selectedRangeData?.daysWithTest}
      testsPerDay={selectedRangeData?.testsPerDay}
      totalRecordCount={selectedRangeData?.totalRecordCount}
      lastTestDate={selectedRangeData?.lastTestDate}
    />
  );

  return (
    <StyledSmbg>
      <div className="view-in-web">
        <div className="web-title">SMBG data quality</div>
        {chart}
      </div>
      <div className="view-in-mobile">
        <MainAccordion header="SMBG data quality" open={'panel1'}>
          {chart}
          <Dropdown>
            <TextAccordion>
              This section aims to provide insight on the quality of SMBG
              performed by the patient. Based on the report time span you can
              easily assess if your patient's glucose monitoring behaviour is
              sufficient or needs improvement.
            </TextAccordion>
          </Dropdown>
        </MainAccordion>
      </div>
    </StyledSmbg>
  );
};

const TextAccordion = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  direction: ltr;
  color: #4e4e4e;
  margin-bottom: 15px;
`;

const StyledSmbg = styled.div`
  width: 100%;
  .view-in-mobile {
    display: block;
  }
  .view-in-web {
    display: none;
  }
  .web-title {
    border-bottom: 1px solid #d8d8d8;
    color: #753cbe;
    font-size: 28px;
    font-family: 'dana-bold';
    letter-spacing: 1px;
    text-align: center;
    width: 340px;
    margin: auto;
    margin-bottom: 50px;
  }
  @media screen and (min-width: 1024px) {
    padding: 0 64px;
    .view-in-mobile {
      display: none;
    }
    .view-in-web {
      display: block;
    }
  }
`;
